import ScaledQuote from './ScaledQuote'
export default ScaledQuote
